import { useContext } from "react";
import { ImpresionContext } from "../../providers/Impresion";
import { PaginatorContext } from "../../providers/Paginator";
import { Button, Icon, Typography, IconButton } from "@mui/material";
import { AddCircleRounded, DeleteOutline } from "@mui/icons-material";
import { toast } from "react-toastify";

const UseTemplate = ({
  children,
  template,
  plantillaData,
  evento,
  tarifa,
  onEliminar,
  onEditar
}) => {
  const {
    elements,
    setElements,
    dimensionContainer,
    setDimensionContainer,
    uploadHistory,
    setIndex
  } = useContext(ImpresionContext);

  const { event } = useContext(PaginatorContext);

  // cargar las plantillas personalizadas que el usuario guarda
  const HandleCustomTemplate = (data) => {
    try {
      const plantillaJson = JSON.parse(data.json);

      let maxWidth, maxHeight;

      if (plantillaJson.type && typeof plantillaJson.type === 'object') {
        maxWidth = plantillaJson.type.width;
        maxHeight = plantillaJson.type.height;
      } else {
        maxWidth = 0;
        maxHeight = 0;

        if (plantillaJson.elements && plantillaJson.elements.length > 0) {
          plantillaJson.elements.forEach(element => {
            if (element.width && element.height) {
              const rightEdge = (element.x || 0) + element.width;
              const bottomEdge = (element.y || 0) + element.height;

              if (rightEdge > maxWidth) maxWidth = rightEdge;
              if (bottomEdge > maxHeight) maxHeight = bottomEdge;
            }
          });
        }

        // si no se encuentran las dimensiones, usar las predet
        if (maxWidth === 0 || maxHeight === 0) {
          const tipo = typeof plantillaJson.type === 'object' ? plantillaJson.type.type : plantillaJson.type;
          maxWidth = tipo === 'pulsera' ? 1000 : (tipo === 'voucher' ? 100 : 480);
          maxHeight = tipo === 'pulsera' ? 100 : (tipo === 'voucher' ? 50 : 240);
        }
      }

      const tipoFinal = typeof plantillaJson.type === 'object' ? plantillaJson.type.type : plantillaJson.type;

      const dimensionesFinales = {
        ...dimensionContainer,
        type: tipoFinal,
        width: maxWidth,
        height: maxHeight
      };

      const elementosActualizados = plantillaJson.elements?.map(element => {
        const elementoActualizado = { ...element };

        if (element.type === 'text-evento' && evento) {
          elementoActualizado.text = evento;
        } else if (element.type === 'text-tarifa' && tarifa) {
          elementoActualizado.text = tarifa;
        } else if (element.type === 'text-nombre') {
          elementoActualizado.text = 'Nombre Apellido';
        } else if (element.type === 'text-idticket') {
          elementoActualizado.text = '012345';
        } else if (element.type === 'text-codigo') {
          elementoActualizado.text = '012345678912';
        } else if (element.type === 'text-talon') {
          elementoActualizado.text = '0000-000';
        } else if (element.type === 'text-mesa') {
          elementoActualizado.text = 'Mesa X';
        } else if (element.type === 'text-asiento') {
          elementoActualizado.text = 'Asiento X';
        } else if (element.type === 'text-fila') {
          elementoActualizado.text = 'Fila A';
        }

        return elementoActualizado;
      }) || [];

      setDimensionContainer(dimensionesFinales);

      setTimeout(() => {
        setElements(elementosActualizados);
        const maxId = elementosActualizados.reduce((max, element) =>
          parseInt(element.id) > max ? parseInt(element.id) : max, 0
        ) || 0;
        setIndex(maxId + 1);
      }, 300);

      setTimeout(() => {
        uploadHistory(elementosActualizados);
      }, 600);

    } catch (error) {
      toast.error("Error al cargar la plantilla: " + error, {
      position: "top-right",
      autoClose: 4000,
    });
    }
  };

  //cargar las plantillas predeterminadas
  const HandleTemplate = (template) => {
    if (template === 'pulsera') {
      setDimensionContainer({ ...dimensionContainer, type: 'pulsera', width: 1000, height: 100 });
      setTimeout(() => {
        setElements([
          {
            "id": "128",
            "x": 146,
            "y": 11,
            "width": 80,
            "height": 80,
            "type": "qr"
          },
          {
            "id": "129",
            "x": 476.99999999999955,
            "y": 26.999999999999986,
            "text": evento,
            "fontSize": 21,
            "rotation": 0,
            "width": 228.69632969085396,
            "height": 25.03974412673583,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text-evento"
          },
          {
            "id": "131",
            "x": 499,
            "y": 59,
            "text": "Nombre Apellido",
            "fontSize": 14,
            "rotation": 0,
            "width": 128,
            "height": 15,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text-nombre"
          }
        ]);
      }, 300);
    }
    if (template === 'tarjeta') {
      setDimensionContainer({ ...dimensionContainer, type: 'tarjeta', width: 480, height: 240 });
      setTimeout(() => {
        setElements([
          {
            "id": "117",
            "x": 287.0125537552901,
            "y": 16.833047947574727,
            "width": 165.77157238457835,
            "height": 165.7715723845781,
            "type": "qr",
            "fontSize": 0
          },
          {
            "id": "122",
            "x": 84,
            "y": 196,
            "text": "Nombre Apellido",
            "fontSize": 14,
            "rotation": 0,
            "width": 170,
            "height": 15,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text-nombre"
          },
          {
            "id": "124",
            "x": 26,
            "y": 196,
            "text": "Nombre:",
            "fontSize": 14,
            "rotation": 0,
            "width": 60.999999999999986,
            "height": 14.999999999999984,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text"
          },
          {
            "id": "126",
            "x": 19.999999999999943,
            "y": 16.00000000000003,
            "text": evento,
            "fontSize": 39,
            "rotation": 0,
            "width": 169.52659490477916,
            "height": 121.26719927495176,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text-evento"
          },
          {
            "id": "127",
            "x": 356.0000000000001,
            "y": 211.00000000000028,
            "text": "012345",
            "fontSize": 14,
            "rotation": 0,
            "width": 175,
            "height": 15.000000000000028,
            "state": false,
            "fontFamily": "Roboto",
            "fontStyle": "normal",
            "textDecoration": "",
            "fill": "#000000",
            "align": "left",
            "type": "text-idticket"
          }
        ]);
      }, 300);
    }

    if (template === 'voucher') {
      setDimensionContainer({ ...dimensionContainer, type: 'voucher', width: 100, height: 50 });
      setTimeout(() => {
        setElements([]);
      }, 300);
    }

    setTimeout(() => {
      uploadHistory(elements);
    }, 600);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
      <Button
        variant="contained"
        color="default"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "50px",
          flex: 1
        }}
        onClick={() =>
          plantillaData
            ? HandleCustomTemplate(plantillaData)
            : HandleTemplate(template)
        }
      >
        <Typography sx={{ width: "auto" }} variant="p">{children}</Typography>
        <Icon sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <AddCircleRounded color="primary" sx={{ fontSize: 24 }} />
        </Icon>
      </Button>

      {plantillaData && (
        <>
          {onEliminar && (
            <IconButton
              size="small"
              color="error"
              onClick={onEliminar}
              title="Eliminar plantilla"
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          )}
        </>
      )}
    </div>
  );
};

export default UseTemplate;
